<div class="icon-with-text" orientation="horizontal" (click)="navigateTo.emit()">
  <rs-web-icon [icon]="icon"></rs-web-icon>
  <span class="text text-smaller ml-5">{{ text }}</span>
</div>
